// This uses Vue for event bus
//
// import Vue from 'vue'
import Events from './events'

// endpoints
const methods = [
  'iam', 'sendChar', 'start'
]

const debug = 0

let log = () => {}

if (debug) {
  log = console.log.bind(console.log,
    '%cSVC:', 'color:#0a0',
    (Math.random() * 1000).toFixed()
  )
}

function WordService () {
  log('New word service')
  // singleton per module
  var ws = null
  var connected = false
  var reconnect = false
  var eventBus = new Events()
  var loc = '' // The location

  // WS Connector
  const connect = () => {
    reconnect = true
    ws = new window.WebSocket(loc)
    ws.onopen = () => {
      log('connected', this.ws)
      connected = true
      eventBus.emit('open')
    }
    ws.onmessage = (e) => { // receiving message
      log('received:', e.data)
      const msg = [].concat(JSON.parse(e.data))
      // If array we send array
      for (let m of msg) {
        if (m.op && m.data) {
          // If it is an operation we pass the operation payload
          eventBus.emit(m.op, m.data)
        } else {
          // Pass message through
          eventBus.emit(m.op, m)
        }
      }
    }
    ws.onerror = (e) => { connected = false }
    ws.onclose = (e) => {
      log('Lost connection', e)
      if (connected === true) {
        eventBus.emit('close')
      } // emit close
      connected = false
      if (!reconnect) {
        return
      }

      setTimeout(() => connect(loc), 3000) // Reconnect
    }
  }
  // Default methods
  const service = { // will work on current connection
    m: {},
    send (msg) {
      log('sent', JSON.stringify(msg))
      if (ws) ws.send(JSON.stringify(msg))
    },
    connected (cb) {
      if (connected === false) {
        eventBus.on('open', cb)
        return
      }
      cb()
    },
    // delegate eventbus
    on: eventBus.on.bind(eventBus),
    // Reconnect
    connect (ploc) {
      loc = ploc
      this.close()

      connect()
      // }
      log('Connecting to', loc)
    },
    reconnect (v) {
      reconnect = v
    },
    // It will reconnect like this
    close () {
      reconnect = false
      if (!ws) { return }
      ws.onopen = undefined
      ws.onmessage = undefined
      ws.onclose = undefined
      ws.close()
    }
  }

  // Create methods
  methods.forEach(ftyp => {
    // ID?
    service.m[ftyp] = (param, id) => {
      log(`sending: op:"${ftyp}" -- ${param}`)
      if (connected) {
        service.send({ op: ftyp, id: id, data: param })
        // return
      }
    }
  })
  Object.assign(this, service)
}

export default WordService
